import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import CustomTooltip from './CustomTooltip';
import PlatformEmailDialogue from './PlatformEmailDialogue';
import * as track from '../../../lib/track';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
    borderBottom: '4px solid transparent',
  },
}));

const PlatformEmail = () => {
  const classes = useStyles();
  const address = useSelector(state => state.auth.profile.platform_email);
  const [detailsOpen, setDetailsOpen] = useState(false);

  const clickDetails = () => {
    track.sendEvent('vault address detail', 'click', {});
    setDetailsOpen(true);
  };

  return (
    <Fragment>
      <CustomTooltip
        arrow
        placement="bottom-end"
        title="Click to learn more"
      >
        <div className={classes.root} onClick={clickDetails}>
          <Typography align="right" variant="body2">
            Your vault address is: <b>{address}</b>
          </Typography>
        </div>
      </CustomTooltip>
      <PlatformEmailDialogue
        open={detailsOpen}
        onClose={()=>setDetailsOpen(false)}
      />
    </Fragment>
  );
};

export default PlatformEmail;
